import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDeleteItem = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="#919499">
      <path d="M3.5 6A1.5 1.5 0 0 1 5 4.5h14A1.5 1.5 0 0 1 20.5 6v2.5h-17V6ZM4.5 8.5h15V20a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 20V8.5ZM9 4.5a2 2 0 0 1 2-2h1.5a2 2 0 0 1 2 2M8 10.5v9M16 10.5v9M12 10.5v9" />
    </g>
  </svg>
);
const Memo = memo(SvgDeleteItem);
export default Memo;
